/* Video Tabs JS */
(function() {
  const init = (s) => {
    const btns = [...s.querySelectorAll('.video-tabs__btn')];
    const panels = [...s.querySelectorAll('.video-tabs__panel')];
    
    const activate = (idx) => {
      btns.forEach((b, i) => {
        const active = i === idx;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active);
        b.tabIndex = active ? 0 : -1;
      });
      panels.forEach((p, i) => {
        p.classList.toggle('is-active', i === idx);
        p.hidden = i !== idx;
      });
    };
    
    s.addEventListener('click', (e) => {
      const btn = e.target.closest('.video-tabs__btn');
      if (btn) activate(btns.indexOf(btn));
    });
    
    s.addEventListener('keydown', (e) => {
      if (!e.target.classList.contains('video-tabs__btn')) return;
      const idx = btns.indexOf(e.target);
      const len = btns.length;
      const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1, Home: -idx, End: len - 1 - idx };
      if (!(e.key in keys)) return;
      e.preventDefault();
      const newIdx = (idx + keys[e.key] + len) % len;
      activate(newIdx);
      btns[newIdx].focus();
    });
  };
  
  document.querySelectorAll('.video-tabs').forEach(init);
  
  /* Fetch Vimeo thumbnails */
  document.querySelectorAll('.vimeo-thumb[data-vimeo-id]').forEach(img => {
    const id = img.dataset.vimeoId;
    if (id) {
      fetch(`https://vimeo.com/api/v2/video/${id}.json`)
        .then(r => r.json())
        .then(data => { if (data[0]) img.src = data[0].thumbnail_large; })
        .catch(() => {});
    }
  });
  
  /* Video Play - Click handler for deferred-media */
  document.querySelectorAll('.video-tabs deferred-media').forEach(media => {
    const poster = media.querySelector('.deferred-media__poster');
    if (poster) {
      poster.addEventListener('click', () => {
        if (!media.getAttribute('loaded')) {
          const template = media.querySelector('template');
          if (template) {
            media.setAttribute('loaded', '');
            media.appendChild(template.content.cloneNode(true));
            poster.style.display = 'none';
          }
        }
      });
    }
  });
})();